<div class="ds-p-lg">
  <div
    class="
      slide-in
      ds-flex
      ds-text-xl
      ds-border-[1px]
      ds-border-tertiary-lightgrey
      ds-inset-x-0
      ds-bottom-0
      ds-p-xs
      ds-bg-primary-white
      ds-z-50
      ds-container
      ds-max-w-3xl
      ds-m-auto
      ds-h-auto
      sm:!ds-min-h-[120px] sm:!ds-px-xl
    "
    *ngIf="isDisplay"
  >
    <div class="ds-flex ds-w-auto ds-items-center ds-px-xs">
      <ng-container [ngSwitch]="type">
        <span *ngSwitchCase="'info'" class="ds-icons-information"></span>
        <span
          *ngSwitchCase="'error'"
          class="ds-icons-alert-cmyk before:!ds-bg-[#F93B18]"
        ></span>
        <span
          *ngSwitchCase="'success'"
          class="ds-icons-check before:!ds-bg-[#3DC07C]"
        ></span>
      </ng-container>
    </div>
    <div
      class="ds-p-2 ds-w-full ds-flex ds-flex-col ds-justify-center ds-px-xs"
    >
      <div *ngIf="title" class="sm:!ds-text-4xl ds-text-xl">
        {{ title }}
      </div>
      <div
        class="sm:!ds-text-xl ds-text-sm"
        [ngClass]="{
          'sm:!ds-pt-2xs ds-pt-sm': title && title!.length < 1
        }"
      >
        {{ message }}
      </div>
    </div>
    <div class="ds-flex ds-w-auto ds-items-center ds-px-xs">
      <button
        *ngIf="buttonMessage"
        (click)="onClose()"
        type="button"
        class="
          ds-button ds-min-w-[10.5rem] ds-text-sm ds-py-2xs
          sm:!ds-py-xs
          sm:!ds-text-base
          sm:!ds-max-w-[35.5rem]
          sm:!ds-min-w-[180px]
          sm:!ds-min-h-[52px]
        "
      >
        {{ buttonMessage }}
      </button>
    </div>
  </div>
</div>
